import {
  MUTATION_CREATE_CUSTOMER_ACCESS_TOKEN,
  MUTATION_RENEW_CUSTOMER_ACCESS_TOKEN,
} from '@allesauto/graphql';
import { consts } from '@allesauto/utils/consts';
import { getAnonymousHeader } from '@allesauto/utils/funcs';
import Cookies from 'js-cookie';
import { NextApiRequest } from 'next';

import { initializeApollo } from '@/global/apollo/apollo';
import { LoginToken } from '@/store/redux/actions/user';

const signIn = async ({
  email,
  password,
  merchantUuids,
  merchantOrigin,
}: {
  email: string;
  password: string;
  merchantOrigin?: string;
  merchantUuids?: string[];
}): Promise<LoginToken | null> => {
  const apolloClient = initializeApollo(
    undefined,
    merchantUuids,
    merchantOrigin
  );
  const uuid = Cookies.get(consts.COOKIES.SHOPPING_CART_UUID);
  const uuidHeader = uuid ? getAnonymousHeader(uuid) : null;

  const result = await apolloClient.mutate({
    mutation: MUTATION_CREATE_CUSTOMER_ACCESS_TOKEN,
    variables: { email, password },
    context: {
      headers: uuidHeader,
    },
  });

  if (result) {
    // Delete the UUID cookie if log-in successful
    Cookies.remove(consts.COOKIES.SHOPPING_CART_UUID);
  }

  if (result?.data?.createCustomerAccessToken?.accessToken) {
    const { accessToken, refreshToken, expiresAt } =
      result.data.createCustomerAccessToken;

    return {
      accessToken,
      refreshToken,
      expiresAt,
    };
  } else {
    return null;
  }
};

const refreshLoginTokens = async (token: string) => {
  const apolloClient = initializeApollo();

  const result = await apolloClient.mutate({
    mutation: MUTATION_RENEW_CUSTOMER_ACCESS_TOKEN,
    variables: {
      customerRefreshToken: token,
    },
  });

  const { accessToken, refreshToken, expiresAt } =
    result.data.renewCustomerAccessToken;

  return {
    accessToken,
    refreshToken,
    expiresAt,
  };
};

// verify JWT sent by the browser to the next.js server

// key env variable contains newlines encoded as __LINE__

// const formatJWTPubKey = (key: string): string => {
//   return key.replace(/__LINE__/g, '\n');
// };

const verifyUserRequestToBeAuthenticated = async (req: NextApiRequest) => {
  const userTokenCookie = req.cookies[consts.COOKIES.USER_TOKEN];
  if (!userTokenCookie) {
    throw new Error('no user session present');
  }

  // let userSuppliedToken;
  try {
    // FIXME: this was deactivated because the key for signing/verifying the jwt changes!!!
    // const userTokenCookieJSON = JSON.parse(userTokenCookie);
    // userSuppliedToken = userTokenCookieJSON['accessToken'];
  } catch {
    throw new Error('no user session present');
  }

  // const jwtPubKeyInline = process.env.JWT_PUB_KEY as string;
  // const jwtPubKey = formatJWTPubKey(jwtPubKeyInline);

  // FIXME: this was deactivated because the key for signing/verifying the jwt changes!!!

  // try {
  //   const algorithm = process.env.JWT_PUB_KEY_ALG as string;
  //   const ecPublicKey = await importSPKI(jwtPubKey, algorithm);
  //
  //   const { payload } = await jwtVerify(userSuppliedToken, ecPublicKey);
  //   return payload;
  // } catch (e) {
  //   throw new Error('no user session present');
  // }

  return true;
};

export { refreshLoginTokens, signIn, verifyUserRequestToBeAuthenticated };
